import bnbPresaleAbi from "./bnbPresaleAbi.json";
import bnbUsdtAbi from "./bnbUSDTAbi.json";
import bnbBUSDAbi from "./bnbBUSDAbi.json";

import {
  bscPresaleAddress,
  bnbUsdtAddress,
  bnbBusdAddress,
} from "./environment";

import { readContract, writeContract } from "wagmi/actions";
import { waitForTransaction } from "@wagmi/core";
import { Alert, Snackbar } from "@mui/material";

export const bnbPresaleReadFunction = async (functionName, args) => {
  const data = await readContract({
    address: bscPresaleAddress,
    abi: bnbPresaleAbi,
    functionName,
    args,
  });
  return data;
};

export const bnbUsdtReadFunction = async (functionName, args) => {
  const data = await readContract({
    address: bnbUsdtAddress,
    abi: bnbUsdtAbi,
    functionName,
    args,
  });
  return data;
};

export const bnbBusdReadFunction = async (functionName, args) => {
  const data = await readContract({
    address: bnbBusdAddress,
    abi: bnbBUSDAbi,
    functionName,
    args,
  });
  return data;
};


/// write functions
export const bnbPresaleWriteFunction = async (functionName, args, value) => {
  const { hash } = await writeContract({
    address: bscPresaleAddress,
    abi: bnbPresaleAbi,
    functionName,
    args,
    value,
  });
  const receipt = await waitForTransaction({ hash });
  return receipt;
};

export const bnbUsdtWriteFunction = async (functionName, args) => {
  const { hash } = await writeContract({
    address: bnbUsdtAddress,
    abi: bnbUsdtAbi,
    functionName,
    args,
  });
  const receipt = await waitForTransaction({ hash });
  return receipt;
};
export const bnbBusdWriteFunction = async (functionName, args) => {
  const { hash } = await writeContract({
    address: bnbBusdAddress,
    abi: bnbBUSDAbi,
    functionName,
    args,
  });
  const receipt = await waitForTransaction({ hash });
  return receipt;
};